/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const PathwayToEngagement = ({
    researchPathwayToEngagement,
}: Partial<{
    researchPathwayToEngagement: string;
}>) =>
    researchPathwayToEngagement ? (
        <Row>
            <ValueCell label="Pathway to Engagement and Impact" value={researchPathwayToEngagement} />
        </Row>
    ) : (
        <></>
    );

export default PathwayToEngagement;
